<template>
  <div>
    <span style="margin-left: 1.5em; margin-right: 3.5em; fontsize: 14px" class="has-text-grey">
      {{ setting.label || name }}
      <Tooltip :label="setting.label || name" :content="setting.detail" />
    </span>

    <el-time-select
      v-model="value[name]"
      placeholder="Select time"
      :picker-options="{ start: '00:00', step: '00:15', end: '23:45' }"
    />
  </div>
</template>

<script>
/**
 * TimeSelect SmartField - Renders a time picker for time configuration values.
 *
 * @component
 * @description Displays a time picker with 15-minute intervals from 00:00 to 23:45.
 * Provides a dropdown list of time slots for easy selection without typing.
 * Stores the selected time as a string in HH:mm format.
 *
 * @prop {Object} value - Parent object containing the setting value
 * @prop {Object} setting - Field configuration object
 * @prop {string} [setting.label] - Display label for the time picker (defaults to name)
 * @prop {string} [setting.detail] - Tooltip text explaining the setting
 * @prop {string} [setting.default] - Default time value in HH:mm format if not set (e.g., '09:00')
 * @prop {string} name - Property key in the value object
 *
 * @example
 * <TimeSelect
 *   :value="config"
 *   :setting="{ label: 'Start Time', detail: 'Select start time', default: '09:00' }"
 *   name="startTime"
 * />
 */
import Tooltip from "../Tooltip.vue";
export default {
  components: { Tooltip },
  props: ["value", "setting", "name"],
  mounted() {
    console.log(this.value[this.name]);
    if (this.value[this.name] == null) {
      if (this.setting.default != null) {
        this.$set(this.value, this.name, this.setting.default);
      } else {
        this.$set(this.value, this.name, null);
      }
    }
  },
};
</script>
